import * as angular from "angular";
import {IController} from "angular";
import {EmploymentType} from "../../types/employment.type";

export class EmploymentTypeSelectListComponent implements IController {

  employmentType: any;
  ngPlaceholder: any;
  onChange: Function;

  private queryString: string;
  private types: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.types = Object.values(EmploymentType);
  }

  submitQuery(query) {
    this.queryString = query;
  }

}

angular
    .module('bringoz.admin.agents')
    .component('employmentTypeSelectList', {
        bindings: {
          employmentType: '<',
          ngPlaceholder: '@?',
          onChange: '&'
        },
        template: require('./employment-type-select-list.html').default,
        controller: EmploymentTypeSelectListComponent
    });
